import React, { useState, useEffect } from "react";
import SuccessModal from "./SuccessModal";
import { useOutletContext } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa";
import config from "../../../config/config";
import axios from "axios";

const BadgesComponent = ({ user }) => {
  const [selections, setSelections] = useState({
    petFriendly: "",
    nonSmoker: "",
    lgbtqia: "",
  });

  const [validationError, setValidationError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const { isSmallScreen, handleBackClick } = useOutletContext();
  const baseURL = config.API_BASE_URL;

  useEffect(() => {
    const fetchBadgeData = async () => {
      if (user && user.id) {
        try {
          const response = await axios.get(
            `${baseURL}/v1/worker-users/${user.id}`
          );
          const fetchedUserData = response.data;
          const badgeData = fetchedUserData.badge;
          if (badgeData) {
            setSelections({
              petFriendly: badgeData.petFriendly,
              nonSmoker: badgeData.nonSmoker,
              lgbtqia: badgeData.lgbtqia,
            });
          }
        } catch (error) {
          console.error("Failed to fetch badge data:", error);
        }
      }
    };

    fetchBadgeData();
  }, [user, baseURL]);

  const handleSelectionChange = (badge, value) => {
    setSelections((prevSelections) => ({
      ...prevSelections,
      [badge]: value,
    }));
    if (validationError) setValidationError("");
  };

  const handleSave = async () => {
    const allSelected = Object.values(selections).every(
      (value) => value !== ""
    );
    if (!allSelected) {
      setValidationError("Please make a selection for each badge option.");
    } else {
      console.log("Badge Selections to be Patched:", selections);
      try {
        const response = await axios.patch(
          `${baseURL}/v1/worker-users/${user.id}`,
          { badge: selections }
        );
        if (response.data) {
          console.log("Patch successful");
          setShowModal(true);
        }
      } catch (error) {
        console.error("Failed to update badge selections", error);
      }
    }
  };

  return (
    <div className="badges-custom-component-container">
      {showModal && <SuccessModal />}
      <div className="profile-back-container">
        {isSmallScreen && (
            <div className="profile-back-arrow" onClick={handleBackClick}>
              <FaAngleLeft className="profile-back-icon"/> 
            </div>
          )}
          <h2>Badges</h2>
        </div>
      
      <p>Would you like to add a badge to your profile?</p>
      <div className="badges-options-container">
        <div className="badge-option">
          <img src="/images/pet-friendly.jpg" alt="Pet Friendly" />
          <h3>Pet Friendly</h3>
          <div className="radio-container">
            <div className="radio-item">
              <input
                type="radio"
                id="petFriendly-yes"
                name="petFriendly"
                value="yes"
                checked={selections.petFriendly === "yes"}
                onChange={() => handleSelectionChange("petFriendly", "yes")}
              />
              <label htmlFor="petFriendly-yes">Yes</label>
            </div>

            <div className="radio-item">
              <input
                type="radio"
                id="petFriendly-no"
                name="petFriendly"
                value="no"
                checked={selections.petFriendly === "no"}
                onChange={() => handleSelectionChange("petFriendly", "no")}
              />
              <label htmlFor="petFriendly-no">No</label>
            </div>
          </div>
        </div>
        <div className="badge-option">
          <img src="/images/non-smoker.jpg" alt="Non Smoker" />
          <h3>Non Smoker</h3>
          <div className="radio-container">
          <div className="radio-item">
              <input
                type="radio"
                id="nonSmoker-yes"
                name="nonSmoker"
                value="yes"
                checked={selections.nonSmoker === "yes"}
                onChange={() => handleSelectionChange("nonSmoker", "yes")}
              />
              <label htmlFor="nonSmoker-yes">Yes</label>
            </div>
            <div className="radio-item">
              <input
                type="radio"
                id="nonSmoker-no"
                name="nonSmoker"
                value="no"
                checked={selections.nonSmoker === "no"}
                onChange={() => handleSelectionChange("nonSmoker", "no")}
              />
              <label htmlFor="nonSmoker-no">No</label>
            </div>
          </div>
        </div>
        <div className="badge-option">
          <img src="/images/icon-image-lgbti.svg" alt="LGBTQIA+ Community" />
          <h3>LGBTQIA+ community</h3>
          <div className="radio-container">
          <div className="radio-item">
              <input
                type="radio"
                id="lgbtqia-yes"
                name="lgbtqia"
                value="yes"
                checked={selections.lgbtqia === "yes"}
                onChange={() => handleSelectionChange("lgbtqia", "yes")}
              />
              <label htmlFor="lgbtqia-yes">Yes</label>
            </div>
            <div className="radio-item">
              <input
                type="radio"
                id="lgbtqia-no"
                name="lgbtqia"
                value="no"
                checked={selections.lgbtqia === "no"}
                onChange={() => handleSelectionChange("lgbtqia", "no")}
              />
              <label htmlFor="lgbtqia-no">No</label>
            </div>
          </div>
        </div>
      </div>
      {validationError && <div className="badge-error">{validationError}</div>}
      <div className="badges-save">
        <button onClick={handleSave}>Save and continue</button>
      </div>
    </div>
  );
};

export default BadgesComponent;
